import React from "react";
import { Box, Card, Typography } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import Grid from "@mui/material/Grid";
import { HierarchyStyles } from "./HierarchyStyles";
import { getCookie } from "../../utils/Utility";

const Hierarchy: React.FC = () => {
  const producerTypeCd = getCookie("producerTypeCd");
  const agencyName = getCookie("name");

  return (
    <Box sx={HierarchyStyles.container}>
      <Box sx={HierarchyStyles.hierarchyContainer}>
        <Box sx={HierarchyStyles.paddingContainer}>
          {producerTypeCd === "Group" ? (
            // Full hierarchy view for Group
            <Grid container justifyContent="center" spacing={2}>
              {/* Root Node - AcmeGroup */}
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={HierarchyStyles.rootNodeCard}>
                  <GroupsIcon sx={HierarchyStyles.rootNodeIcon} />
                  <Typography variant="h6" sx={HierarchyStyles.rootNodeText}>
                    AcmeGroup
                  </Typography>
                </Card>
              </Grid>

              {/* Child Nodes with their sub-nodes */}
              <Grid
                container
                justifyContent="center"
                spacing={4}
                sx={HierarchyStyles.childNodeContainer}
              >
                {/* Left Branch - acmeagtx with children */}
                <Grid item xs={12} sm={6} md={3}>
                  <Card sx={HierarchyStyles.branchCard}>
                    <GroupIcon sx={HierarchyStyles.branchIcon} />
                    <Typography variant="h6" sx={HierarchyStyles.branchText}>
                      acmeagtx
                    </Typography>
                  </Card>
                  <Grid
                    container
                    spacing={2}
                    sx={HierarchyStyles.subNodeContainer}
                  >
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea1</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea2</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea5</Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Right Branch - acmeagpa with children */}
                <Grid item xs={12} sm={6} md={3}>
                  <Card sx={HierarchyStyles.branchCard}>
                    <GroupIcon sx={HierarchyStyles.branchIcon} />
                    <Typography variant="h6" sx={HierarchyStyles.branchText}>
                      acmeagpa
                    </Typography>
                  </Card>
                  <Grid
                    container
                    spacing={2}
                    sx={HierarchyStyles.subNodeContainer}
                  >
                    <Grid item xs={6}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea3</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={6}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea4</Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : producerTypeCd === "Agency" ? (
            // Agency-specific view
            <Grid container justifyContent="center" spacing={2}>
              {agencyName === "Acme Agency1" ? (
                // View for Acme Agency1
                <Grid item xs={12} sm={6}>
                  <Card sx={HierarchyStyles.rootNodeCard}>
                    <GroupIcon sx={HierarchyStyles.rootNodeIcon} />
                    <Typography variant="h6" sx={HierarchyStyles.rootNodeText}>
                      acmeagtx
                    </Typography>
                  </Card>
                  <Grid
                    container
                    spacing={2}
                    sx={HierarchyStyles.subNodeContainer}
                  >
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea1</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea2</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea5</Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              ) : agencyName === "Acme Agency2" ? (
                // View for Acme Agency2
                <Grid item xs={12} sm={6}>
                  <Card sx={HierarchyStyles.rootNodeCard}>
                    <GroupIcon sx={HierarchyStyles.rootNodeIcon} />
                    <Typography variant="h6" sx={HierarchyStyles.rootNodeText}>
                      acmeagpa
                    </Typography>
                  </Card>
                  <Grid
                    container
                    spacing={2}
                    sx={HierarchyStyles.subNodeContainer}
                  >
                    <Grid item xs={6}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea3</Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={6}>
                      <Card sx={HierarchyStyles.subNodeCard}>
                        <PersonIcon sx={HierarchyStyles.subNodeIcon} />
                        <Typography>acmea4</Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default Hierarchy;
